const getClassFromSet = (classList: string, classSet: RegExp | string[]) => {
  const classListArr = classList.trim().split(' ');
  return classSet instanceof RegExp ?
    classListArr.find(option => classSet.test(option)) :
    classListArr.find(option => classSet.includes(option));
}

export default getClassFromSet;